import * as React from "react";

import LogoIcon from "@/components/common/LogoIcon";
import LogoText from "@/components/common/LogoText";

type Orientation = "horizontal" | "vertical";
type ThemeMode = "light" | "dark";

export interface BrandLogoProps {
  orientation?: Orientation;

  theme?: ThemeMode;

  iconSize?: number | string;

  textWidth?: number | string;
  textHeight?: number | string;

  gap?: number;

  className?: string;

  iconPrimaryColor?: string;
  iconSecondaryColor?: string;

  textColor?: string;

  hideText?: boolean;
  hideIcon?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
  orientation = "horizontal",
  theme = "light",

  iconSize = 48,

  textWidth = 180,
  textHeight = "auto",

  gap = 12,

  className,

  iconPrimaryColor,
  iconSecondaryColor,

  textColor,

  hideText = false,
  hideIcon = false,
}) => {
  const isDark = theme === "dark";

  const resolvedTextColor = textColor ?? (isDark ? "#FFFFFF" : "#000000");

  const resolvedPrimaryColor = iconPrimaryColor ?? (isDark ? "#FFFFFF" : "#171911");

  const resolvedSecondaryColor = iconSecondaryColor ?? (isDark ? "#FEBF10" : "#FEBF10");

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: orientation === "vertical" ? "column" : "row",
        gap,
        width: "fit-content",
      }}
    >
      {!hideIcon && (
        <LogoIcon size={iconSize} primaryColor={resolvedPrimaryColor} secondaryColor={resolvedSecondaryColor} />
      )}

      {!hideText && <LogoText width={textWidth} height={textHeight} color={resolvedTextColor} />}
    </div>
  );
};

export default BrandLogo;
